export const POLICY__INVOICE_VIEW__TITLE = 'Invoice';
export const POLICY__INVOICE_VIEW__PAY_INVOICE_BUTTON = 'Pay Invoice';
export const POLICY__INVOICE_VIEW__WRITE_OFF_BUTTON = 'Write Off';
export const POLICY_INVOICE_VIEW__REVERSE_PAYMENT_BUTTON_TEXT =
	'Reverse Payment';
export const POLICY_INVOICE_VIEW__DOWNLOAD_INVOICE_BUTTON = 'Download Invoice';
export const POLICY_INVOICE_VIEW__COPY_INVOICE_BUTTON = 'Copy Invoice Locator';
export const POLICY_INVOICE_VIEW__COPY_INVOICE_SUCCESS_TOAST =
	'Invoice locator copied to clipboard';
